// extracted by mini-css-extract-plugin
export var active = "pill-module--active--84b1f";
export var pill = "pill-module--pill--4c887";
export var pillIcon = "pill-module--pill-icon--f988d";
export var pillText = "pill-module--pill-text--37ac7";